<template lang="pug">
  a(:href="post.link", title="title").post
    .img-wrap
      img(:src="post.featured_image_url", alt="")
    .text
      h2(v-html="post.title.rendered")
      .excerpt(v-html="post.excerpt.rendered")

</template>

<script>
export default {
  props: {
    post: {
      type: Object
    }
  }
}
</script>
<style lang="scss" scoped>
  .post{
    position: relative;
    max-height: 70vh;
    display: grid;
    align-items: flex-end;
    .img-wrap{
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
    }

    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    &:after{
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 40%;
      background: linear-gradient(transparent, black);
      z-index: 2;
    }
    &:before{
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
      background: url('~@/assets/diagonal-noise.png') repeat;
      z-index: 2;
    }
  }
  .text{
    position: relative;
    padding: 1rem;
    color: white;
    z-index: 3;
    h2{
      font-weight: 900;
      text-transform: uppercase;
      font-size: 2rem;
    }
    .excerpt{
      display: none;
    }
    p{
      font-size: 1rem;
      line-height: 1rem;
    }
  }
</style>
